import React, { useState } from 'react';

// Styles

import { darculaSettingsStyles } from '../darculaTheme';

const {
    settingsNumericInputStyle,
    settingsNumericInputFocusStyle,
    settingsStepperGroupStyle,
    settingsStepperButtonStyle,
} = darculaSettingsStyles;

const RegularInputForSettings = props => {

    const {
        value,
        settingName,
        switchers,
        handleInputChange
    } = props;

    const [ localState, toggleLocalState ] = useState(value);
    const [ inputFocused, setInputFocused ] = useState(false);

    const handleCLickingSwitchers = direction => {
        const base = Number(localState);
        const next = direction === 'minus' ? base - 1 : base + 1;
        handleInputChange({ target: { name: settingName, value: next } }, true);
        toggleLocalState(next);
    };

    const handleChange = e => {
        handleInputChange(e);
        toggleLocalState(e.target.value);
    };

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <input
                type="text"
                inputMode="numeric"
                autoComplete="off"
                style={{
                    ...settingsNumericInputStyle,
                    ...(inputFocused ? settingsNumericInputFocusStyle : {}),
                }}
                value={ localState }
                name={ settingName }
                onChange={ e => handleChange(e) }
                onFocus={ () => setInputFocused(true) }
                onBlur={ () => setInputFocused(false) }
            />
            {
                switchers && (
                    <span style={ settingsStepperGroupStyle }>
                        <button
                            type="button"
                            onClick={ () => handleCLickingSwitchers('plus') }
                            style={ settingsStepperButtonStyle }
                            aria-label="Increase value"
                        >
                            +
                        </button>
                        <button
                            type="button"
                            onClick={ () => handleCLickingSwitchers('minus') }
                            style={ settingsStepperButtonStyle }
                            aria-label="Decrease value"
                        >
                            -
                        </button>
                    </span>
                )
            }
        </span>
    );

};

export default RegularInputForSettings;
